/**
 * Ce qu'une ligne de remboursement a à dire, tiré de l'échéancier que la Paie
 * a rendu dans `contenu.remboursement`.
 *
 * De la mise en forme seulement : l'écran ne calcule aucune retenue. Il résume
 * ce que la Paie a fait — prélevé, reste dû — et repère la prochaine échéance.
 */

/** Les demandes qui ont un échéancier dans la Paie. */
export function avecRemboursement(demandes) {
  return demandes.filter(
    (demande) => (demande.contenu?.remboursement?.echeances || []).length > 0
  );
}

/**
 * Résumé d'un remboursement pour une ligne de tableau.
 *
 * La mensualité est celle de la prochaine échéance, ou de la dernière si tout
 * est prélevé : c'est ce que le salarié verra partir, pas une moyenne.
 */
export function resumer(demande) {
  const { echeances = [], preleve = 0, reste_du: reste } = demande.contenu?.remboursement || {};
  const ordonnees = [...echeances].sort((a, b) => a.mois.localeCompare(b.mois));
  const prochaine = ordonnees.find((echeance) => echeance.statut !== 'prelevee') || null;
  const total = typeof reste === 'number' ? preleve + reste : null;
  return {
    montant: demande.contenu?.montant,
    preleve,
    reste: typeof reste === 'number' ? reste : null,
    pourcentage: total ? Math.round((preleve / total) * 100) : null,
    prochaine,
    mensualite: (prochaine || ordonnees[ordonnees.length - 1] || {}).montant,
    fin: ordonnees.length ? ordonnees[ordonnees.length - 1].mois : null,
    echeances: ordonnees,
  };
}
